import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted } from 'vue'
import { AvailableYear, LocationType } from '../model/types/report'
import { getReportBreadcrumbs } from '../model/helpers'
import { setBreadcrumbs } from '@/features/Breadcrumbs'
import { useRoute } from 'vue-router'
import { useReportStore } from '@/pages/Report'
import { districtList } from '@/shared/consts/common'
import ReportLayoutSlide from '@/pages/Report/ui/Layouts/ReportLayoutSlide.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegionSlideMode',
  setup(__props) {

const route = useRoute()
const reportStore = useReportStore()
const region = computed(() => ({
	population: reportStore.state.commonInfo?.population,
	density: reportStore.state.commonInfo?.populationDensity,
	type: 'region' as LocationType,
	name: districtList[route.params.districtId].regions.find(region => region.id === Number(route.params.regionId)).name
}))

onMounted(() => {
	setBreadcrumbs(getReportBreadcrumbs(
		region.value.type,
		route.params.year as AvailableYear,
		Number(route.params.regionId)
	))
})
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReportLayoutSlide, { target: _unref(region) }, null, 8, ["target"]))
}
}

})